import {
    FetchState,
    OutageNotificationState,
    OutageNotification
} from "@/shared/types";
import {
    getOutageNotification,
    postOutageNotification
} from "@/shared/api/userService";

import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: OutageNotificationState = {
    fetchState: FetchState.Uninitialized,
    outageNotification: null,
};


export const useOutageNotificationStore = defineStore("outageNotification", {
    state: () => (_.cloneDeep(initialState)),
    getters: {
        isLoading: state => state.fetchState === FetchState.Loading,
        isLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setOutageNotification (notification: OutageNotification) {
            this.outageNotification = notification;
            this.fetchState = FetchState.Loaded;
        },
        loadOutageNotification () {
            if (this.isLoaded) {
                return Promise.resolve();
            }
            this.setFetchState(FetchState.Loading);
            return getOutageNotification()
                .then(response => {
                    this.setOutageNotification(response.data);
                })
                .catch(error => {
                    this.setFetchState(FetchState.Uninitialized);
                    return storeHelper.handleError({ error, rethrow: false });
                });
        },
        beginSetOutageNotification (notification: OutageNotification) {
            return postOutageNotification(notification)
                .then(() => {
                    this.setOutageNotification(notification);
                })
                .catch(error => {
                    this.setFetchState(FetchState.Uninitialized);
                    return storeHelper.handleError({ error, rethrow: false });
                });
        }
    }
});